<template>
	<div>
		<BaseDrawer
			:show.sync="isShow"
			:title="title"
			size="xl"
			data-test-id="drawer-add-wysiwyg"
			@close="close"
		>
			<template #header-actions>
				<CButton
					color="secondary"
					class="mr-2"
					:disabled="!slug"
					@click="handlePreview"
				>
					<CIcon class="mr-2" name="cil-magnifying-glass" />Preview content
				</CButton>
			</template>

			<template v-if="isShow">
				<CRow>
					<CCol lg="12">
						<label>Description (EN) *</label>
						<BaseRichTextEditor
							v-model="$v.form.contentEn.$model"
							:is-valid="!$v.form.contentEn.$error"
							:invalid-feedback="contentErrors($v.form.contentEn)"
							name="contentEn"
							size="large"
						/>
					</CCol>
					<CCol lg="12" class="mt-3">
						<label>Description (TH) *</label>
						<BaseRichTextEditor
							v-model="$v.form.contentTh.$model"
							:is-valid="!$v.form.contentTh.$error"
							:invalid-feedback="contentErrors($v.form.contentTh)"
							name="contentTh"
							size="large"
						/>
					</CCol>
				</CRow>
			</template>

			<template #footer>
				<BaseModalFooter
					:disabled-confirm="disabledConfirm"
					@onCancel="close"
					@onConfirm="handleSubmit"
				/>
			</template>
		</BaseDrawer>
	</div>
</template>


<script>
import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import BaseDrawer from '@/components/BaseDrawer.vue';
import BaseModalFooter from '@/components/BaseModalFooter.vue';
import { jsonLdScriptOnly } from '../../assets/js/validators';
import { WIDGET_TYPE, WIDGET_VISIBILITY } from '../../enums/widgets';

export default {
	name: 'ModalAddWYSIWYG',
	components: {
		BaseDrawer,
		BaseModalFooter,
	},
	props: {
		slug: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			isShow: false,
			title: 'Add Content',
			isEdit: false,
			form: {
				name: '',
				contentEn: '',
				contentTh: '',
				websiteVisibility: WIDGET_VISIBILITY.true,
				mobileVisibility: WIDGET_VISIBILITY.true,
			},
		};
	},
	validations: {
		form: {
			contentTh: {
				required,
				jsonLdScriptOnly,
			},
			contentEn: {
				required,
				jsonLdScriptOnly,
			},
		},
	},
	computed: {
		...mapState('pages', {
			edit: 'editWidget',
		}),
		disabledConfirm() {
			return this.$v.$invalid || this.edit.isLoading;
		},
	},
	methods: {
		/**
		 * ข้อความ error ของช่อง content — แยก "ยังไม่กรอก" ออกจาก "JSON-LD ที่วางไว้พัง"
		 * (แพตเทิร์นเดียวกับ `FormPages.vue` เพราะสองที่นี้เป็นคอนเทนต์ชุดเดียวกันคนละ feature)
		 *
		 * @param {Object} field
		 * @returns {String|null}
		 */
		contentErrors(field) {
			if (!field.required) {
				return this.$t('global.error.required');
			}

			if (!field.jsonLdScriptOnly) {
				return 'ใน content มี <script> ที่ไม่ใช่ application/ld+json หรือ JSON-LD ที่วางไว้ไม่ถูกต้อง — เปิด View > Code เพื่อแก้';
			}

			return null;
		},
		async open(data = null) {
			this.isShow = true;
			this.setFormData(data);
		},
		close() {
			this.$v.$reset();
			this.isShow = false;
		},
		setFormData(data) {
			this.title = this.form.contentEn ? 'Edit WYSIWYG Content' : 'Add WYSIWYG Content';

			this.form.name = data?.name ?? '';
			this.form.contentEn = data?.contentEn ?? data?.['content_en'] ?? '';
			this.form.contentTh = data?.contentTh ?? data?.['content_th'] ?? '';

			const isActive = data?.isActive ?? data?.['is_active'];
			this.form.websiteVisibility = isActive === 0 || isActive === false ? WIDGET_VISIBILITY.false : WIDGET_VISIBILITY.true;

			const isMobileActive = data?.isMobileActive ?? data?.['is_mobile_active'];
			this.form.mobileVisibility = isMobileActive === 0 || isMobileActive === false ? WIDGET_VISIBILITY.false : WIDGET_VISIBILITY.true;
		},
		handleSubmit() {
			if (this.$v.$invalid) {
				return;
			}
			this.form.type = WIDGET_TYPE.wysiwyg;
			this.$emit('onSubmit', this.form);
		},
		handlePreview() {
			const baseUrl = process.env.VUE_APP_ECOM_ENDPOINT;
			const previewUrl = `${baseUrl}/th/mock/content?slug=${this.slug}`;
			window.open(previewUrl, '_blank');
		},
	},
};
</script>
